module.exports = __webpack_public_path__ + "static/img/800.e78e455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/800.png
// module id = 7lcy
// module chunks = 2